import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {LocalStorage} from '../../utils/LocalStorage';

class DemoButton extends Component {
    render() {
        const {t} = this.props;
        const agencyStatus = LocalStorage.fetchAgencyStatus();

        if (agencyStatus !== "Free Trial") {
            return null;
        }

        return (
            <div className="demo-button-container">
                <a
                    href="https://calendly.com/pablo-dashbo/demo-30-minutos"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="demo-button"
                >
                    <i className="fa fa-calendar-alt"></i>
                    <span>{t('demo_button.button_text')}</span>
                    <div className="demo-tooltip">
                        {t('demo_button.tooltip_text')}
                    </div>
                </a>
            </div>
        );
    }
}

export default withTranslation()(DemoButton);
